import * as React from 'react'

export const SidebarOpenedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.7 3.1h6.8v8.8H2.7a.4.4 0 0 1-.4-.4v-8c0-.22.18-.4.4-.4Zm0-.8a1.2 1.2 0 0 0-1.2 1.2v8a1.2 1.2 0 0 0 1.2 1.2h9.6a1.2 1.2 0 0 0 1.2-1.2v-8a1.2 1.2 0 0 0-1.2-1.2H2.7Z"
      clipRule="evenodd"
    />
  </svg>
)
